/**
 * Determines the URL of the page logo that is currently configured in Liferay.
 *
 * @author cls
 */
export function getPageLogoUrl(): string {
  return window.EHSPageLogo ?? '/o/EHealthTheme/images/logo_bright_small.png';
}
